<template>
  <!-- 用户管理 - 企业人员管理 author: zhangxiaofeng R2 第二迭代 废弃 ... -->
  <div class="padding-10" id="user-content">
    <w-row :gutter="16">
      <w-col :span="16">
        <w-row>
          <w-col :span="24">
            <div class="background-white box-shadow item-card border-radius-2 product-info relative">
              <div class="card-title">造价云-黄金版</div>
              <div class="product-center">
                <w-button type="minor">产品中心</w-button>
              </div>
              <div class="card-wrapper">
                <div class="used-container">
                  <div class="used-info">共520G / 已用 270G</div>
                  <div class="surplus">剩余 250G</div>
                </div>
                <div class="used-image">
                  <i class="process blue" style="width: 30%;"></i>
                  <i class="process green" style="width: 10%;"></i>
                  <i class="process purple" style="width: 10%;"></i>
                  <i class="process yellow" style="width: 10%;"></i>
                  <i class="process red" style="width: 10%;"></i>
                </div>
                <div class="flex to-do-lists">
                  <div class="to-do-item flex-1">
                    <div class="to-do-title">150G</div>
                    <div class="to-do-desc">
                      <i class="radius blue"></i>项目库
                    </div>
                  </div>
                  <div class="to-do-item flex-1">
                    <div class="to-do-title">50G</div>
                    <div class="to-do-desc">
                      <i class="radius green"></i>员工资料库
                    </div>
                  </div>
                  <div class="to-do-item flex-1">
                    <div class="to-do-title">30G</div>
                    <div class="to-do-desc">
                      <i class="radius purple"></i>备案库
                    </div>
                  </div>
                  <div class="to-do-item flex-1">
                    <div class="to-do-title">20G</div>
                    <div class="to-do-desc">
                      <i class="radius yellow"></i>企业共享空间
                    </div>
                  </div>
                  <div class="to-do-item flex-1">
                    <div class="to-do-title">20G</div>
                    <div class="to-do-desc">
                      <i class="radius red"></i>计价依据库
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </w-col>
          <w-col :span="24">
            <div class="background-white box-shadow item-card border-radius-2 margin-top-16 project-preview relative">
              <div class="card-title">员工及权限管理</div>
              <div class="employee-manage">
                <w-button type="minor">人员管理</w-button>
              </div>
              <div class="card-wrapper flex to-do-lists">
                <div class="to-do-item flex-1">
                  <div class="to-do-title">1</div>
                  <div class="to-do-desc">总负责人</div>
                  <div class="to-do-footer">
                    <div class="active flex">
                      <div class="active-name name">活跃(3个月内)</div>
                      <div class="active-number flex-1">0</div>
                    </div>
                    <div class="silent flex">
                      <div class="silent-name name">活跃(3个月内)</div>
                      <div class="silent-number flex-1">0</div>
                    </div>
                  </div>
                </div>
                <div class="to-do-item flex-1">
                  <div class="to-do-title">1</div>
                  <div class="to-do-desc">管理员</div>
                  <div class="to-do-footer">
                    <div class="active flex">
                      <div class="active-name name">活跃(3个月内)</div>
                      <div class="active-number flex-1">0</div>
                    </div>
                    <div class="silent flex">
                      <div class="silent-name name">活跃(3个月内)</div>
                      <div class="silent-number flex-1">0</div>
                    </div>
                  </div>
                </div>
                <div class="to-do-item flex-1">
                  <div class="to-do-title">64</div>
                  <div class="to-do-desc">普通员工</div>
                  <div class="to-do-footer">
                    <div class="active flex">
                      <div class="active-name name">活跃(3个月内)</div>
                      <div class="active-number flex-1">0</div>
                    </div>
                    <div class="silent flex">
                      <div class="silent-name name">活跃(3个月内)</div>
                      <div class="silent-number flex-1">0</div>
                    </div>
                  </div>
                </div>
                <div class="to-do-item flex-1">
                  <div class="to-do-title">12</div>
                  <div class="to-do-desc">档案室负责人</div>
                  <div class="to-do-footer">
                    <div class="active flex">
                      <div class="active-name name">活跃(3个月内)</div>
                      <div class="active-number flex-1">0</div>
                    </div>
                    <div class="silent flex">
                      <div class="silent-name name">活跃(3个月内)</div>
                      <div class="silent-number flex-1">0</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </w-col>
        </w-row>
      </w-col>
      <w-col :span="8">
        <w-row>
          <w-col :span="24">
            <div class="background-white box-shadow item-card border-radius-2 to-do">
              <div class="card-title">我的待办</div>
              <div class="card-wrapper flex to-do-lists">
                <div class="flex-1 to-do-item">
                  <div class="to-do-radius share">1</div>
                  <div class="to-do-desc">员工账号申请</div>
                </div>
                <div class="flex-1 to-do-item">
                  <div class="to-do-radius comment">0</div>
                  <div class="to-do-desc">角色待分配</div>
                </div>
                <div class="flex-1 to-do-item">
                  <div class="to-do-radius project">16</div>
                  <div class="to-do-desc">企业数据库管理</div>
                </div>
              </div>
            </div>
          </w-col>
          <w-col :span="24">
            <div class="background-white box-shadow item-card border-radius-2 margin-top-16">
              <div class="card-title">企业产品管理</div>
              <div class="card-wrapper">
                <Echart id="project-manage" :style="{width: '100%', height: '240px'}"
                        :option="productManage.option"></Echart>
              </div>
              <div class="card-footer text-align-center padding-20-0" style="padding-top: 50px;">
                <w-button type="minor">查询资产配置</w-button>
              </div>
            </div>
          </w-col>
        </w-row>
      </w-col>
    </w-row>
  </div>
</template>
<script>
import {Echart} from '@/components/common'

export default {
  name: 'ManageHome',
  components: {
    Echart
  },
  data () {
    return {
      productManage: {
        option: {
          title: {
            text: '18',
            textStyle: {
              fontSize: 32,
              color: '#212530'
            },
            subtext: '已购资产',
            left: 'center',
            top: '100px'
          },
          tooltip: {
            trigger: 'item',
            formatter: '{b} : {c} ({d}%)'
          },
          color: ['#2079FA', '#FFC51B'],
          // tooltip: {
          //   formatter: function (params) {
          //     return `${params.name}：${params.value}`;
          //   }
          // },
          legend: {
            bottom: 0,
            itemWidth: 8,
            itemHeight: 8,
            itemGap: 10,
            data: ['已分配资产', '未分配资产'],
            textStyle: {
              fontSize: 12,
              color: 'rgba(33,37,48,0.55)'
            }
          },
          series: [
            {
              name: '项目模块',
              type: 'pie',
              radius: ['50%', '70%'],
              avoidLabelOverlap: false,
              label: {
                show: false,
                position: 'center'
              },
              data: [
                {value: 15, name: '已分配资产'},
                {value: 3, name: '未分配资产'}
              ],
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        }
      }
    }
  }
}
</script>
<style lang="less" type="text/less">
  #user-content {
    .table-body-wrapper {
      top: -49px;
    }

    .item-card {
      padding: 16px 24px;

      .card-title {
        height: 22px;
        font-size: 14px;
        font-weight: bold;
        color: rgba(33, 37, 48, 1);
        line-height: 22px;
        cursor: default;
        -webkit-user-select: none;
      }

      &.product-info {
        .product-center {
          position: absolute;
          width: 88px;
          height: 32px;
          top: 16px;
          right: 24px;
        }
        .card-title {
          height:26px;
          font-size:18px;
          line-height:26px;
        }
        .card-wrapper {
          padding: 40px 0 20px 0;
          .used-container {
            display: flex;
            .used-info {
              flex: 1;
              height:22px;
              font-size:14px;
              font-weight:400;
              color:rgba(33,37,48,0.8);
              line-height:22px;
            }
            .surplus {
              width: 150px;
              height:22px;
              text-align: right;
              font-size:14px;
              font-weight:400;
              color:rgba(33,37,48,0.8);
              line-height:22px;
            }
          }
          .used-image {
            width: 100%;
            height:20px;
            margin-top: 12px;
            background:rgba(33,37,48,0.1);
            display: flex;
            .process {
              height:20px;
              &.blue {
                background: rgba(32, 121, 250, 1);
              }

              &.green {
                background: rgba(23, 217, 158, 1);
              }

              &.purple {
                background: rgba(45, 70, 127, 1);
              }

              &.yellow {
                background: rgba(255, 197, 27, 1);
              }

              &.red {
                background: rgba(249, 103, 83, 1);
              }
            }
          }
          .to-do-lists {

            .to-do-item {
              border-left: 1px solid rgba(33, 37, 48, 0.1);
              padding-left: 20px;
              margin: 20px 0;

              &:first-child {
                border-left: 1px solid transparent;
                padding-left: 0px;
              }

              .to-do-title {
                height: 36px;
                font-size: 20px;
                font-weight: 400;
                color: rgba(33, 37, 48, 1);
                line-height: 36px;
              }

              .to-do-desc {
                height: 22px;
                font-size: 14px;
                font-weight: 400;
                color: rgba(33, 37, 48, 0.55);
                line-height: 22px;

                .radius {
                  width: 8px;
                  height: 8px;
                  border-radius: 50%;
                  margin: 7px 7px 7px 0;
                  display: block;
                  float: left;

                  &.blue {
                    background: rgba(32, 121, 250, 1);
                  }

                  &.green {
                    background: rgba(23, 217, 158, 1);
                  }

                  &.purple {
                    background: rgba(45, 70, 127, 1);
                  }

                  &.yellow {
                    background: rgba(255, 197, 27, 1);
                  }

                  &.red {
                    background: rgba(249, 103, 83, 1);
                  }
                }
              }
            }
          }
        }
      }

      &.project-preview {
        height: 276px;

        .employee-manage {
          position: absolute;
          width: 88px;
          height: 32px;
          top: 16px;
          right: 24px;
        }

        .card-wrapper {
          &.to-do-lists {
            padding: 20px 0;

            .to-do-item {
              border-left: 1px solid rgba(33, 37, 48, 0.1);
              text-indent: 20px;
              margin: 20px 0;

              &:first-child {
                border-left: 1px solid transparent;
                text-indent: 0px;
              }

              .to-do-title {
                height: 40px;
                font-size: 32px;
                font-weight: 400;
                color: rgba(33, 37, 48, 1);
                line-height: 40px;
              }

              .to-do-desc {
                font-size: 12px;
                font-weight: 400;
                color: rgba(33, 37, 48, 0.75);
                line-height: 20px;
                padding-top: 10px;
              }

              .to-do-footer {
                padding-top: 30px;
                .name {
                  font-size:12px;
                  font-weight:400;
                  color:rgba(33,37,48,0.55);
                  line-height:20px;
                }
              }
            }
          }
        }
      }

      &.to-do {
        height: 152px;

        .card-wrapper {
          &.to-do-lists {
            padding: 20px 0;

            .to-do-item {
              .to-do-radius {
                width: 46px;
                height: 46px;
                border-radius: 50%;
                font-size: 18px;
                font-weight: 500;
                color: rgba(255, 255, 255, 1);
                line-height: 46px;
                margin: 0 auto;
                text-align: center;
                cursor: pointer;

                &.share {
                  background: linear-gradient(360deg, rgba(71, 157, 255, 1) 0%, rgba(0, 104, 255, 1) 100%);
                }

                &.comment {
                  background: linear-gradient(360deg, rgba(31, 241, 220, 1) 0%, rgba(0, 192, 207, 1) 100%);
                }

                &.project {
                  background: linear-gradient(360deg, rgba(252, 157, 121, 1) 0%, rgba(231, 64, 66, 1) 100%);
                }

                &.company {
                  background: linear-gradient(360deg, rgba(54, 208, 255, 1) 0%, rgba(0, 159, 255, 1) 100%);
                }
              }

              .to-do-desc {
                font-size: 12px;
                font-weight: 400;
                color: rgba(33, 37, 48, 0.75);
                line-height: 20px;
                text-align: center;
                padding-top: 10px;
              }
            }
          }
        }
      }

    }
  }
</style>
